export const TEXT_DIRECTION = {
    LTR: 'ltr',
    RTL: 'rtl',
} as const;

/**
 * Anchor character which changes base directionality of text to be LTR
 */
export const START_LTR_EMBED_ANCHOR = '\u202A';

/**
 * Anchor character which ends a change to LTR base directionality
 */
export const END_LTR_EMBED_ANCHOR = '\u202C';

/**
 * Anchors last character of provided string, where anchor refers to
 * prepending with start anchor character and appending with end anchor character
 * in order to fix incorrect rendering in RTL languages
 *
 * @param {String} input
 * @return {String} same string with last character anchored by anchor characters
 * @public
 */
export function anchorLastChar(input: string): string {
    if (typeof document === 'undefined') {
        return input;
    }

    const isRTL = document.dir === TEXT_DIRECTION.RTL;
    if (!isRTL) {
        return input;
    }

    const lastChar = input.slice(-1);
    const isAlphanumeric = /^[a-z0-9]+$/i.test(lastChar);
    const isAnchor = lastChar === END_LTR_EMBED_ANCHOR;
    if (isAlphanumeric || isAnchor) {
        return input;
    }

    return input.replace(
        /.$/,
        `${START_LTR_EMBED_ANCHOR}${lastChar}${END_LTR_EMBED_ANCHOR}`,
    );
}
